(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuListAuthorizedController', OnuListAuthorizedController);

    OnuListAuthorizedController.$inject = ['$scope', '$stateParams', '$rootScope', '$filter', '$sce', '$translate', '$q', 'OnuData', 'OnuService', 'OltService', 'RequestService', 'Authenticate', 'BridgeService'];

    function OnuListAuthorizedController($scope, $stateParams, $rootScope, $filter, $sce, $translate, $q, OnuData, OnuService, OltService, RequestService, Authenticate, BridgeService) {

        if (!Authenticate.hasPermission('onuList')) {
            return;
        }

        // Variables and Objects
        var vm = this;
        var hasError = false;
        var dataSearch = {};
        vm.requestRunning = false;

        vm.currentPage = 1;
        vm.totalCount = 0;
        vm.itemsPerPage = 50; 

        vm.arrayOnus = [];
        vm.selectedOnus = []

        vm.list = {};
        vm.view = {};
        vm.list.checkBoxEnable = false;
        vm.orderSelected = '';
        vm.view.labelOrderSelected = '';
        vm.view.menuSelectAll = 'disable';
        vm.view.menuSelectIndividual = 'disable';
        vm.view.panelButton = false;

        vm.list.typeOrder = [
            {translateKey: 'alphabeticalOrderAToZ', name: 'Ordem alfabética (a-z)', paramObjectOrder: 'name'},
            {translateKey: 'alphabeticalOrderZToA', name: 'Ordem alfabética (z-a)', paramObjectOrder: '-name'},
            {translateKey: 'inclusionFirstOrder', name: 'Ordem de inclusão (asc)', paramObjectOrder: 'id'},
            {translateKey: 'inclusionLastOrder', name: 'Ordem de inclusão (desc)', paramObjectOrder: '-id'}
        ];
        vm.view.tooltip = '';
        vm.searchIsActive = false;

        // Method handler
        vm.toggleCollapse = toggleCollapse;
        vm.unselectAll = unselectAll;
        vm.typeSelection = typeSelection;
        vm.addAndRemoveItem = addAndRemoveItem;
        vm.setTypeOrder = setTypeOrder;
        vm.hasSearch = hasSearch;
        vm.hasNoSearch = hasNoSearch;
        vm.hasErrorList = hasErrorList;
        vm.hasWiFi = hasWiFi;
        vm.reload = reload;
        vm.disableSelection = disableSelection;
        vm.isONTAndONU110Gi = isONTAndONU110Gi;
        vm.isOltIntelbras = isOltIntelbras;
        vm.isNotONU110G = isNotONU110G;

        // Method Api
        vm.restartOnu = restartOnu;
        vm.deleteOnu = deleteOnu;
        vm.editOnu = editOnu;
        vm.updateOnu = updateOnu;
        vm.resetOnu = resetOnu;
        vm.isONT = isONT;
        vm.getStatusVoip = getStatusVoip;
        vm.configAccess = configAccess;
        vm.configOnu = configOnu;
        vm.getOnuCpeMgr = getOnuCpeMgr;
        vm.getData = getData;

        vm.addBridge = addBridge;

        function addBridge(onuItem) {
            BridgeService.addBridgeOnuModalConstructor($scope, onuItem);
        }

        initialize();

        // Method handler
        function setTypeOrder(type) {
            toggleCollapse(null);
            vm.orderSelected = type;
            setLabelOrderText(type);
        }

        // Update the OLT data when it is edited
        var cleanListener = $rootScope.$on('onuUpdateSuccess', updateOnuData);
        $scope.$on('$destroy', cleanListener);

        // Clear the ONU checkbox when it is deleted and restarted
        var listener = $rootScope.$on('onuActionSuccess', clearSelection);
        $scope.$on('$destroy', listener);

        var firmwareListener = $rootScope.$on('onuUpdateFirmware', reload);
        $scope.$on('$destroy', listener);

        function typeSelection(typeSelection) {
            vm.list.checkBoxEnable = true;
            toggleCollapse(null);

            switch (typeSelection) {
                case 'selectAll':
                    if (checkStatusOption(vm.view.isActiveOptionAll)) {
                        toggleMenuActive(false);
                        return;
                    }
                    selectAll();
                    toggleMenuActive('selectAll');
                    break;
                case 'selectIndividual':
                    if (checkStatusOption(vm.view.isActiveOptionIndividual)) {
                        toggleMenuActive(false);
                        return;
                    }
                    selectIndividual();
                    toggleMenuActive('selectIndividual');
                    break;
            }
        }

        function addAndRemoveItem(item) {

            if (item.selected) {
                vm.selectedOnus.push(item);
                showPanelButton();
            } else {
                angular.forEach(vm.selectedOnus, function (itemDetail, index) {
                    if (!item.selected && itemDetail.id == item.id) {
                        vm.selectedOnus.splice(index, 1);
                    }
                });
                if (vm.selectedOnus.length == 0) {
                    hidePanelButton();
                }
            }
        }

        function selectAll() {
            vm.selectedOnus = [];
            showPanelButton();
            angular.forEach(vm.arrayOnus, function (item) {
                item.selected = true;
                vm.selectedOnus.push({
                    id: item.id,
                    name: item.name,
                    mostCriticalAlarm: item.mostCriticalAlarm,
                    selected: true
                });
            });
        }

        function selectIndividual() {
            unselectAll();
            vm.selectedOnus = [];

            if (vm.selectedOnus.length == 0) {
                hidePanelButton();
            }
        }

        function unselectAll() {
            vm.selectedOnus = [];
            hidePanelButton();
            angular.forEach(vm.arrayOnus, function (item) {
                item.selected = false;
            });
        }

        function toggleMenuActive(option) {
            if (option) {
                if (option == 'selectAll') {
                    vm.view.isActiveOptionAll = true;
                    vm.view.isActiveOptionIndividual = false;
                    vm.view.menuSelectAll = 'enable';
                    vm.view.menuSelectIndividual = 'disable';
                } else {
                    vm.view.isActiveOptionAll = false;
                    vm.view.isActiveOptionIndividual = true;
                    vm.view.menuSelectAll = 'disable';
                    vm.view.menuSelectIndividual = 'enable';
                }
            } else {
                vm.view.isActiveOptionAll = false;
                vm.view.isActiveOptionIndividual = false;
                vm.view.menuSelectAll = 'disable';
                vm.view.menuSelectIndividual = 'disable';
            }
        }

        function hasSearch() {
            return !vm.requestRunning && OnuData.isSearch && !vm.arrayOnus.length && !hasError;
        }

        function hasNoSearch() {
            return !vm.requestRunning && !OnuData.isSearch && !vm.arrayOnus.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.arrayOnus.length && hasError;
        }

        // Function to control the show or not the button ONU config according the me profile
        function hasWiFi(onuItem) {
            return onuItem.meProfile == 'intelbras-142ng';
        }

        // private method
        function checkStatusOption(status) {
            if (status) {
                unselectAll();
                vm.list.checkBoxEnable = false;
                return true;
            }
            return false;
        }

        function setLabelOrderText(type) {
            switch (type) {
                case 'name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[0]['translateKey'];
                    break;
                case '-name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[1]['translateKey'];
                    break;
                case 'id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[2]['translateKey'];
                    break;
                case '-id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[3]['translateKey'];
                    break;
            }
        }

        function hidePanelButton() {
            vm.view.panelButton = false;
        }

        function showPanelButton() {
            vm.view.panelButton = true;
        }


        function isONTAndONU110Gi(meProfile) {
            if (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng' || meProfile == 'intelbras-110gi' || meProfile == 'intelbras-121w' || meProfile == 'intelbras-142nw' || meProfile == 'intelbras-default') {
                return true;
            }
            return false;
        }

        function isOltIntelbras(onuItem) {
            if (onuItem.oltModel == 'Intelbras8820i') {
                return true;
            }
            return false;

        }

        function toggleCollapse(id) {
            vm.arrayOnus.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                    if (item.description != null) {
                        item.name = item.description;
                    }
                } else {
                    item.opened = false;
                }
            });
        }

        function reload() {
            getAuthorizedOnuList(dataSearch);
            clearSelection();
        }

        function clearSelection(event) {
            vm.selectedOnus = [];
            hidePanelButton();
            vm.list.checkBoxEnable = false;
            toggleMenuActive(false);
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.updateOnuList').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function updateOnuData(event, data) {
            vm.arrayOnus.forEach(function (onu) {
                if (onu.id == data.id) {
                    if (onu.name != data.name) {
                        onu.name = data.name
                    }
                    if (onu.accessUser != data.accessUser) {
                        onu.accessUser = data.accessUser
                    }
                    if (onu.accessPassword != data.accessPassword) {
                        onu.accessPassword = data.accessPassword
                    }
                }
            });
        }

        // Method API
        function addOnu(event, data) {
            vm.arrayOnus.push(OnuData.parseOnu(data));
            if (vm.list.checkBoxEnable) {
                clearSelection();
            }
        }

        function getAuthorizedOnuList(data) {
            RequestService.cancelRequests(['onus']);
            dataSearch = angular.copy(data);         
            getData(vm.currentPage);
        }

        /*
        function getOnuStatus(event, data) {
            var params = {
                name: data.name,
                getStatus: true,
                noSearch: true
            };
            //OnuService.getAuthorizedOnuList(params, true).then(successListWithStatus);
        }

        function successList(data) {
            if (Object.keys(data).length) {
                vm.arrayOnus = data.map(OnuData.parseOnu);
                var params = angular.copy(dataSearch);
                params.getStatus = true;
                params.noSearch = true;
                //OnuService.getAuthorizedOnuList(params, true).then(successListWithStatus);
            }
            hasError = false;
            setRequest();
        }

        function successListWithStatus(data) {
            vm.arrayOnus.forEach(function (onu) {
                var onuWithStatus = $filter('filter')(data, {id: onu.id}, true);
                if (onuWithStatus.length) {
                    onuWithStatus = OnuData.parseOnu(onuWithStatus[0]);
                    onu.statusGpon = onuWithStatus.statusGpon;
                    onu.rxPower = onuWithStatus.rxPower;
                    onu.txPower = onuWithStatus.txPower;
                    onu.distance = onuWithStatus.distance;
                    onu.softwareVersion = onuWithStatus.softwareVersion;
                }
            });
        }

        function errorListOnu(response) {
            if (response.status != -1) {
                hasError = true;
                setRequest();
            }
        }
        */

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        function restartOnu(onu) {
            var dataAction = {
                action: 'restart',
                methodService: 'restartOnu',
                methodExtra: function (onuList, onuErrorList) {

                    vm.selectedOnus = [];

                    vm.arrayOnus.forEach(function (item) {
                        item.selected = false;
                    });

                    if (onuErrorList) {

                        onuErrorList.forEach(function (onuError) {
                            vm.arrayOnus.forEach(function (onu, index, array) {
                                if (onu.id == onuError.id) {
                                    onu.selected = true;
                                    addAndRemoveItem(onu);
                                }
                            });
                        });

                    } else {
                        hidePanelButton();
                        checkStatusOption(true);
                        toggleMenuActive(false);
                    }
                }
            };

            OnuService.confirmationModalConstructor(onu ? [onu] : vm.selectedOnus, dataAction);
        }

        function deleteOnu(onu) {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteOnu',
                methodExtra: function (onuList, onuErrorList) {

                    if (onuErrorList) {
                        // Remove onus with error on delete from selected list
                        onuErrorList.forEach(function (onuError) {
                            onuList.forEach(function (selectedOnu, index, array) {
                                if (onuError.id == selectedOnu.id) {
                                    array.splice(index, 1);
                                }
                            });
                        });
                    }

                    // Remove deleted onus from onu list
                    onuList.forEach(function (selectedOnu) {
                        vm.arrayOnus.forEach(function (onu, index, array) {
                            if (onu.id == selectedOnu.id) {
                                array.splice(index, 1);
                            }
                        });
                    });

                    vm.selectedOnus = [];
                    hidePanelButton();
                    $rootScope.$broadcast('onuItemDeleted');
                }
            };
            OnuService.confirmationModalConstructor(onu ? [onu] : vm.selectedOnus, dataAction);
        }

        function editOnu(onuItem) {
            OnuService.editOnuModalConstructor(onuItem);
        }

        function updateOnu(onu) {
            OnuService.updateOnuModalConstructor(onu ? [onu] : vm.selectedOnus);
        }

        function resetOnu(onu) {
            checkGtp(onu.oltId).then(function () {
                var dataAction = {
                    action: 'reset',
                    methodService: 'resetOnu',
                    confirmation: true,
                    afterConfirmAction: 'confirmReset'
                };
                OnuService.confirmationModalConstructor([onu], dataAction);
            });
        }

        function isONT(meProfile) {
            if (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng' || meProfile === 'intelbras-default') {
                return true;
            } else {
                return false;
            }

        }

        function getStatusVoip(idOnu) {
            OnuService.openModalONTStatusVoip(idOnu);
        }

        function getOnuCpeMgr(idOnu) {
            OnuService.openModalOnuRemoteMgmt(idOnu);
        }

        function isNotONU110G(meProfile) {
            if (meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                return false;
            } else {
                return true;
            }
        }

        function configAccess(onuItem) {
            OnuService.configAccessModalConstructor(onuItem);
        }

        function configOnu(onuItem, typeCall) {
            OnuService.configOnuModalConstructor(onuItem, true);
            disableSelection();
        }

        function disableSelection() {
            if (vm.list.checkBoxEnable) {
                clearSelection();
            }
        }

        function checkGtp(oltId) {
            return OltService.getOlt(oltId)
                    .then(function (data) {
                        if (!data.gtpCpeMgrId) {
                            return OltService.gtpCpeMgrModalConstructor(oltId, $scope, true).result;
                        }
                        return $q.resolve();
                    });
        }


        function getData(pageNumber) {
            setRequestStart();
            vm.currentPage = pageNumber;   
            if (dataSearch) {
                var data = angular.copy(dataSearch);         
                data.currentPage = (pageNumber - 1);
            } else {
                var data = {
                    currentPage : (pageNumber - 1)
                }
            }

            vm.arrayOnus = []; 
            
            OnuService.getAuthorizedOnuList(data, true).then(function(response){
                vm.arrayOnus = response.data.content;  // data to be displayed on current page.
                vm.totalCount = response.data.totalElements; // total data count.
                setRequestEnd();
            });
            
        }
 
        function initialize() {
            if (!$stateParams.name) {
                getData(vm.currentPage);
            }
            vm.orderSelected = 'id';
            setLabelOrderText('id');
            getTooltip();
        }

        $scope.$on('onuSearch', function (event, data) {
            vm.unselectAll();
            vm.list.checkBoxEnable = false;
            toggleMenuActive(false);
            getAuthorizedOnuList(data);
            dataSearch = data || {};
        });

        $scope.$on('onuNewItemAuthorized', addOnu);
        //$scope.$on('getOnuStatus', getOnuStatus);
    }
})();